import React, { useEffect, useMemo, useState } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import TemplateSelector from 'components/TemplateSelector/TemplateSelector';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import ScrollToTop from 'components/ScrollToTop/ScrollToTop';
import { IntlProvider } from 'react-intl';
import { useAppSelector } from 'app/hooks';
import { selectCoreSettings } from 'features/content/selectors';
import SessionTimeout from './components/SessionTimeout/SessionTimeout';
import {
  selectLocalePath,
  selectMasterLanguage,
  selectUser,
} from 'features/core/selectors';
import EpiserverContext from 'common/utils/episerverContext';
import { getParamValue } from 'common/helpers/urlParams';
import './App.scss';
import { useHistory } from 'react-router-dom';
export const PAGE_TITLE = 'Hoist Finance';
export const CMS_PATH = 'cms';

const App = () => {
  const { pathname, search } = useLocation();
  const [isAuthenticated, setIsAuthtenticated] = useState(false);
  const isEpiserverCms = pathname.includes(CMS_PATH); // Check is CMS
  const editParam = getParamValue(search, 'epieditmode');
  const isEditMode = editParam === undefined ? false : !!isEpiserverCms; // If not CMS then false, otherwise get param value
  const isPreviewMode = editParam === undefined ? false : !isEditMode; // If not CMS then false, otherwise negation of IsEditMode
  const siteSettings = useAppSelector(selectCoreSettings);
  const localePath = useAppSelector(selectLocalePath);
  const masterLanguage = useAppSelector(selectMasterLanguage);
  const user = useAppSelector(selectUser);
  const [gtmOneTrustScriptsIncluded, SetGtmOneTrustScriptsIncluded] =
    useState(false);
    const [metaNoIndexIncluded, SetMetaNoIndexIncluded] =
    useState(false);
  const sessionTimeout = useMemo(() => {
    const sessionTimeout = siteSettings?.LayoutModel?.SessionTimeout;
    return sessionTimeout ? sessionTimeout * 60 * 1000 : null;
  }, [siteSettings?.LayoutModel?.SessionTimeout]);
  const history = useHistory();
  const popstateupdate = useMemo(() => {
    window.addEventListener('popstate', (e) => {
      if (e.type == 'popstate') {
        window.location.href = history.location.pathname;
      }
    });
  }, [siteSettings?.PageData?.SiteSettings?.GoogleTagManagerId]);

  const GoogleAnalyticsScript = () => {
    var globalSiteTag0 =
      'window.dataLayer = window.dataLayer || [];' +
      'function gtag() { dataLayer.push(arguments); }' +
      "gtag('consent', 'default', {ad_storage: 'denied',analytics_storage: 'denied',wait_for_update: 500});" +
      "gtag('set', 'ads_data_redaction', true);";

    var script0 = document.createElement('script');
    script0.type = 'text/javascript';
    script0.innerHTML = globalSiteTag0;
    document.head.appendChild(script0);
  };

  const GtmScripts = () => {
    var gtmId = siteSettings?.PageData?.SiteSettings?.GoogleTagManagerId.trim();

    var gtmScripts =
      "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
      "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
      "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
      "})(window,document,'script','dataLayer'," +
      "'" +
      gtmId +
      "');";
    var script1 = document.createElement('script');
    script1.innerHTML = gtmScripts;
    document.head.appendChild(script1);
  };

  const GtmNoScripts = () => {
    var gtmId = siteSettings?.PageData?.SiteSettings?.GoogleTagManagerId.trim();
    var script = document.createElement('noscript');
    var iframe = document.createElement('iframe');
    iframe.setAttribute(
      'src',
      'https://www.googletagmanager.com/ns.html?id=' + gtmId,
    );
    iframe.setAttribute('height', '0');
    iframe.setAttribute('width', '0');
    script.appendChild(iframe);
    document.body.appendChild(script);
  }; 

  const setMetaTag = useMemo(() => {
    var environment = siteSettings?.LayoutModel?.Environment;
    if (environment && environment !== 'PROD' && !metaNoIndexIncluded)
    {
      var meta = document.createElement('meta');
      meta.setAttribute('name','robots');
      meta.setAttribute('content','noindex');      
      document.head.appendChild(meta);
      SetMetaNoIndexIncluded(true);
    }
    

    
  }, [siteSettings?.LayoutModel]);

  const includeScripts = useMemo(() => {
    var gtmid = siteSettings?.PageData?.SiteSettings?.GoogleTagManagerId;

    if (siteSettings !== undefined && !gtmOneTrustScriptsIncluded) {
      if (gtmid) {
        GoogleAnalyticsScript();
        GtmScripts();
        GtmNoScripts();        
      }
      if (siteSettings?.PageData?.SiteSettings?.HeaderHtml) {
        var div = document.createElement('div');
        div.innerHTML = siteSettings?.PageData?.SiteSettings?.HeaderHtml;

        var nodes = div.children;
        Array.from(nodes).forEach(function (element) {
          if (element.tagName.toUpperCase() === 'STYLE') {
            var style = document.createElement('style');
            style.innerHTML = element.innerHTML;
            document.head.appendChild(style);
          }

          if (element.tagName.toUpperCase() === 'SCRIPT') {
            var oneTrustScript = document.createElement('script');
            var oneTrustScriptElement = element as HTMLScriptElement;

            if (oneTrustScriptElement.type) {
              oneTrustScript.type = oneTrustScriptElement.type;
            }
            if (oneTrustScriptElement.src) {
              oneTrustScript.src = oneTrustScriptElement.src;
            }
            var dataDocumentLanguage = oneTrustScriptElement.getAttribute(
              'data-document-language',
            );
            if (dataDocumentLanguage) {
              oneTrustScript.setAttribute(
                'data-document-language',
                dataDocumentLanguage,
              );
            }
            if (oneTrustScriptElement.charset) {
              oneTrustScript.charset = oneTrustScriptElement.charset;
            }
            var dataDomainScript =
              oneTrustScriptElement.getAttribute('data-domain-script');
            if (dataDomainScript) {
              oneTrustScript.setAttribute(
                'data-domain-script',
                dataDomainScript,
              );
            }
            oneTrustScript.innerHTML = oneTrustScriptElement.innerHTML;
            document.head.appendChild(oneTrustScript);
          }
        });
      }
      SetGtmOneTrustScriptsIncluded(true);
    }
  }, [siteSettings?.PageData?.SiteSettings?.GoogleTagManagerId]);

  useEffect(() => {
    if (user != null) {
      setIsAuthtenticated(true);
    } else {
      setIsAuthtenticated(false);
    }
  }, [user]);

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: siteSettings?.PageData?.Language,
        }}
      >
        <html lang={siteSettings?.PageData?.Language}></html>
      </Helmet>
      <div className="App">
        {sessionTimeout && isAuthenticated && (
          <SessionTimeout
            timeOutValue={sessionTimeout}
            pageData={siteSettings?.PageData?.SiteSettings?.SessionExpiration}
          />
        )}
        <EpiserverContext.Provider value={{ isEditMode, isPreviewMode }}>
          {' '}
          {/* Use 'useContext() to read mode from component */}
          <Helmet>
            <title>{PAGE_TITLE}</title>
            {siteSettings?.PageData?.MetaDescription && (
              <meta
                name="description"
                content={siteSettings?.PageData?.MetaDescription}
              />
            )}
            {siteSettings?.PageData?.MetaAuthor && (
              <meta
                name="author"
                content={siteSettings?.PageData?.MetaAuthor}
              />
            )}
          </Helmet>
          <BaseLayout
            settings={siteSettings}
            localePath={localePath}
            masterLanguage={masterLanguage}
            user={user}
          >
            <IntlProvider locale={masterLanguage}>
              <ScrollToTop>
                <Switch>
                  <Route
                    path="/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/cms/portal/*"
                    component={TemplateSelector}
                  />
                  <Route path="/cms/portal/*" component={TemplateSelector} />
                  <Route
                    path="/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/portal/*"
                    component={TemplateSelector}
                  />
                  <Route path="/portal/*" component={TemplateSelector} />
                  <Route path="/app/*" component={TemplateSelector} />
                  <Route path="/pay/*" component={TemplateSelector} />
                  <Route
                    path="/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/pay/*"
                    component={TemplateSelector}
                  />
                  <Route path="/pay" component={TemplateSelector} />
                  <Route
                    path="/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/pay"
                    component={TemplateSelector}
                  />
                  <Route path="/platnosc/*" component={TemplateSelector} />
                  <Route
                    path="/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/platnosc/*"
                    component={TemplateSelector}
                  />
                  <Route path="/platnosc" component={TemplateSelector} />
                  <Route
                    path="/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/platnosc"
                    component={TemplateSelector}
                  />
                </Switch>
              </ScrollToTop>
            </IntlProvider>
          </BaseLayout>
        </EpiserverContext.Provider>
      </div>
    </>
  );
};

export default App;
